import { render } from "./Book.vue?vue&type=template&id=fb8e71e4&ts=true"
import script from "./Book.vue?vue&type=script&lang=ts"
export * from "./Book.vue?vue&type=script&lang=ts"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/DangKyKB_HV/DKKB_new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__